import { h, Component, Listen, State, Host } from '@stencil/core';

@Component({
  shadow: false,
  styleUrl: 'igws-back-to-top.less',
  tag: 'igws-back-to-top',
})
export class BackToTopComponent {
  @State() scroll: number = window.pageYOffset || document.documentElement.scrollTop;

  @Listen('scroll', { target: 'window' })
  handleScroll() {
    this.scroll = window.pageYOffset || document.documentElement.scrollTop;
  }

  handleClick() {
    if (this.scroll > 1) {
      const newScroll = this.scroll - this.scroll / 5;
      window.scrollTo(0, newScroll);
      this.scroll = newScroll; // Update state to reflect actual position
      window.requestAnimationFrame(this.handleClick.bind(this));
    } else {
      window.scrollTo(0, 0);
      this.scroll = 0;
    }
  }

  render() {
    return <Host onClick={() => this.handleClick()} class={`${this.scroll > 500 ? 'show' : ''}`}></Host>;
  }
}
